import Vue from 'vue'
import Router from 'vue-router'

import Sweety from './@route/sweety'
import Activty from './@route/activty'
import Creativity from './@route/creativity'
import Common from './@route/common'
import Setting from './@route/setting'
import Coupon from './@route/coupon'
import Platform from './@route/platform'
import Order from './@route/order'
import hostingPage from './@route/hostingPage'
import logOut from './@route/logOut'
import Protocol from './@route/protocol'
import Question from './@route/question'
import channelPage from './@route/channelPage'
import Service from './@route/service'
import Good from './@route/good'
import drainageActivity from './@route/drainageActivity'
import multiCategory from './@route/multiCategory'
const routes = [
  ...Activty,
  ...Creativity,
  ...Sweety,
  ...Common,
  ...Setting,
  ...Coupon,
  ...Platform,
  ...Order,
  ...hostingPage,
  ...Protocol,
  ...logOut,
  ...Question,
  ...channelPage,
  ...Service,
  ...Good,
  ...drainageActivity,
  ...multiCategory
]

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/zlj/zljzz_mall_h5/',
  routes
})
